/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import '../../../../types/globals.d.ts';

export interface IDocumentationMetadataProps {
	lastModified?: string;
	filePath: string;
}

export const DocumentationMetadata: React.FC<IDocumentationMetadataProps> = ({ lastModified, filePath }) => {
	const baseClass = BEM("edt-documentation-content");

	const formatDate = (dateString: string) => {
		const date = new Date(dateString);
		return date.toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'long',
			day: 'numeric'
		});
	};

	const gitlabUrl = `${__GITLAB_REPO_URL__}/-/blob/${__GITLAB_BRANCH__}/docs/${filePath}`;

	return (
		<>
			<div className={baseClass.element("separator").toClassName()} />
			<div className={baseClass.element("metadata").toClassName()}>
				<div className={baseClass.element("metadata-left").toClassName()}>
					{lastModified && (
						<span>Last modified: {formatDate(lastModified)}</span>
					)}
				</div>
				<div className={baseClass.element("metadata-right").toClassName()}>
					<a href={gitlabUrl} target="_blank" rel="noopener noreferrer">
						Edit on GitLab
					</a>
				</div>
			</div>
		</>
	);
};
